export default __webpack_public_path__ + "static/media/learning.332283af.svg";